import type { AnyAction, Dispatch } from 'redux';

import { twilioActions } from '../../actions/twilioActions';
import { handleDeviceError } from '../errorCodes';
import type { TwilioEventNotifiers } from '../types';

const {
  twilioChangeDeviceStatus,
  twilioAddActiveCall,
  twilioEstablishedCall,
  twilioMissedCall,
  twilioDisconnectedCall,
  twilioFeedbackSucceeded,
  twilioFeedbackFailed,
} = twilioActions;

// Bridges Twilio SDK events into Redux actions. The SDK runtime calls these
// notifiers when device or call state changes; dispatching actions here keeps
// the rest of the app decoupled from the SDK and lets reducers/sagas react
// to telephony events through the normal Redux flow.
export function buildEventHandlers(
  dispatch: Dispatch<AnyAction>,
): TwilioEventNotifiers {
  return {
    onDeviceStatusChanged: (device) =>
      dispatch(twilioChangeDeviceStatus(device)),
    onDeviceError: (error) => handleDeviceError({ error, dispatch }),

    onIncomingCall: ({ from, to }) =>
      dispatch(twilioAddActiveCall(null, from, to, 'inbound', Date.now())),
    onCallMissed: () => dispatch(twilioMissedCall()),

    onCallEstablished: ({ csid, muted }) =>
      dispatch(twilioEstablishedCall({ csid, muted })),
    onCallTerminated: ({ message }) =>
      dispatch(twilioDisconnectedCall({ message })),

    onFeedbackSucceeded: (result) => dispatch(twilioFeedbackSucceeded(result)),
    onFeedbackFailed: (error) => dispatch(twilioFeedbackFailed(error)),
  };
}
